// 💾 src/pages/auth/Login.tsx
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { signInWithEmailAndPassword } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"
import { auth, db } from "../../services/firebase"
import { useTranslation } from "react-i18next"
import "./style/Login.scss"

const Login = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { lng = "en" } = useParams()

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError("")

    try {
      const result = await signInWithEmailAndPassword(auth, email, password)
      const user = result.user

      // Fetch user role from Firestore
      const userRef = doc(db, "users", user.uid)
      const userSnap = await getDoc(userRef)

      let role: "admin" | "client" = "client"
      if (userSnap.exists()) {
        const data = userSnap.data()
        if (data.role === "admin") {
          role = "admin"
        }
      }

      const path = role === "admin" ? "/admin/dashboard" : `/${lng}/user/profile`
      navigate(path)
    } catch (err: any) {
      setError(err.message || "Login failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-info">
        <h2>{t("auth.login.slogan")}</h2>
        <div className="features">
          <div><strong>160</strong><span>{t("auth.login.countries")}</span></div>
          <div><strong>1961</strong><span>{t("auth.login.tokens")}</span></div>
          <div><strong>36B+</strong><span>{t("auth.login.volume")}</span></div>
          <div><strong>71M+</strong><span>{t("auth.login.users")}</span></div>
        </div>
      </div>

      <div className="login-form">
        <form onSubmit={handleLogin}>
          <h2>{t("auth.login.welcome")}</h2>

          <label>{t("auth.email")}</label>
          <input
            type="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label>{t("auth.password")}</label>
          <input
            type="password"
            required
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="form-footer">
            <button type="submit" disabled={loading}>
              {loading ? t("auth.loggingIn") : t("auth.login.button")}
            </button>
            <span onClick={() => navigate(`/${lng}/forgot-password`)} className="forgot">
              {t("auth.forgot")}
            </span>
          </div>

          {error && <p className="error">{error}</p>}

          <div className="signup-link">
            {t("auth.noAccount")}{" "}
            <span onClick={() => navigate(`/${lng}/register`)}>
              {t("auth.login.register")}
            </span>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
